<template>
    <div class="app-layout" :class="{ 'app-layout--sidebar-mobile': sidebarOnMobile }" :style="layoutVars">
        <the-nav />
        <slot name="top" />

        <div class="layout-body">
            <slot name="body-start" />
            <the-sidebar class="layout-sidebar" />
            <main class="layout-main">
                <slot />
            </main>
        </div>

        <the-footer />
        <mobile-bottom-nav />
        <slot name="floating" />
    </div>
</template>

<script>
// Page shell shared by every page: nav, sidebar, main column, footer, bottom nav.
//   <app-layout padding="32px 50px 48px" :gap="16"> ...page content... </app-layout>
export default {
    name: 'AppLayout',
    props: {
        maxWidth: { type: Number, default: 900 },
        padding: { type: String, default: '32px 0 48px' },
        gap: { type: Number, default: 20 },
        mobilePadding: { type: String, default: '16px 12px' },
        mobileGap: { type: Number, default: null },
        sidebarOnMobile: { type: Boolean, default: false }
    },
    computed: {
        layoutVars() {
            return {
                '--layout-max-width': `${this.maxWidth}px`,
                '--layout-padding': this.padding,
                '--layout-gap': `${this.gap}px`,
                '--layout-padding-mobile': this.mobilePadding,
                '--layout-gap-mobile': `${this.mobileGap ?? this.gap}px`
            };
        }
    }
};
</script>

<style lang="scss" scoped>
.app-layout {
    min-height: 100vh;
    background: var(--bg);
    display: flex;
    flex-direction: column;
    overflow-x: hidden;

    @media (max-width: 768px) {
        padding-bottom: 80px;
    }
}

.layout-body {
    display: flex;
    flex: 1;
    justify-content: space-around;
}

.app-layout:not(.app-layout--sidebar-mobile) .layout-sidebar {
    @media (max-width: 768px) {
        display: none !important;
    }
}

.app-layout--sidebar-mobile .layout-body {
    @media (max-width: 768px) {
        flex-wrap: wrap;
        align-items: flex-start;
        padding: 8px;
        gap: 0;
    }
}

.layout-main {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    margin-left: var(--sidebar-width, 64px);
    padding: var(--layout-padding);
    gap: var(--layout-gap);
    max-width: var(--layout-max-width);
    transition: margin-left 0.3s ease;

    @media (max-width: 768px) {
        margin-left: 0;
        padding: var(--layout-padding-mobile);
        gap: var(--layout-gap-mobile);
        max-width: none;
    }
}
</style>
